module.exports = __webpack_public_path__ + "static/media/transaction-list.10a55b45.svg";